import { Box, IconButton, Typography } from "@mui/material"
import { memo, } from "react"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles";
import { useTranslation } from "react-i18next";


const CatalogValues = ({ values, deleteValue }: { values: { id: number; value: string; }[]; deleteValue: (id: number) => void }) => {

    const styles = useStyles()
    const { t } = useTranslation()

    return (
        <>
            {!!values.length && <Typography sx={styles.secondSubtitle}>{t('dropList.titles.catalogValues')}</Typography>}

            <Box sx={styles.items}>
                {values.map((value) => (
                    <Box
                        key={value.id}
                        sx={styles.item}>
                        <Typography>
                            {value.value}
                        </Typography>
                        <IconButton
                            className="add"
                            sx={styles.delete}
                            onClick={() => {
                                deleteValue(value.id)
                            }}
                        >
                            {icons('cancel-filled')}
                        </IconButton></Box>
                ))}
            </Box>
        </>
    )
}

export default memo(CatalogValues);
